<template>
  <div style="height: 100vh">
    <div class="filter-container">
      <div class="filter-main-container">
        <i class="material-icons clear_icon pointer" @click="$router.go(-1)">clear</i>
        <div class="div-1">Currently showing</div>
        <div class="div-2"></div>

        <div style="width: 100%" class="filter-header white--text">
          <div v-if="!isAnyTagSelected">All spots</div>
          <div v-else class="selected-tag-onload">
            <div class="name">
              {{selectedTagName.name}}
              <i
                class="material-icons"
                @click="SelectTag(selectedTagName.type, selectedTagName.name, selectedTagName.index)"
                style="font-size: 1em; margin-bottom: -0.1em"
              >cancel</i>
            </div>
          </div>
          <div
            style="display: flex; justify-content: flex-end; align-items: center;margin-top: 0.2em;"
          >
            <div class="t-1">in</div>
            <div class="t-2">
              <div class="search-container">
                <select
                  @change="query_location,goToRoute($store.state.search_loc.query_location)"
                  v-model="$store.state.search_loc.query_location"
                  class="search-location-dropdown pointer"
                >
                  <option value disabled selected hidden>Worldwide</option>
                  <option>Worldwide</option>
                  <option>Barcelona</option>
                  <option>Berlin</option>
                  <option>Copenhagen (København)</option>
                  <option>Florence (Firenze)</option>
                  <option>Lisbon (Lisboa)</option>
                  <option>London</option>
                  <option>Los Angeles</option>
                  <option>Madrid</option>
                  <option>Milan (Milano)</option>
                  <option>New York</option>
                  <option>Paris</option>
                  <option>Porto</option>
                  <option>Rome (Roma)</option>
                  <option>San Francisco</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-header-container">
        <div class="div-1">Select a filter to limit results</div>
        <div class="div-2"></div>
      </div>

      <div style="overflow-y: auto" class="scroll-contain">
        <div
          v-for="(tag,tagName) in tags"
          :key="tagName"
          class="text-xs-left pointer"
        >
        <div v-if="tagName === 'spotType'">
          <div class="pl-3 tagline">{{tag.tagLine}}</div>

          <div class="tagTypes">
            <div v-for="(tagselect,tagIndex) in tag.tagArr" :key="tagIndex">
              <div
                class="tag-container"
                :id="`tag-id-${tagName}-${tagIndex}`"
                @click="SelectTag(tagName, tagselect.tag, tagIndex)"
                :style="`background-image: url(${filterImage(tagselect.photoId)}); height:${tag.height === 'small'? '6.429em': '11.429em'}`"
              >
                <!--img :src="filterImage(tagselect.photoId)"/-->
                <div class="tagName" :id="`tag-id-${tagName}-${tagIndex}-name`">
                  <div style="text-align: left;">
                    {{tagselect.tag}}
                    <span v-if="tagselect.pic_cnt > 0">({{tagselect.pic_cnt}})</span>
                  </div>
                  <i
                    class="material-icons"
                    v-show="tag.selectedTags.includes(tagselect.tag)"
                  >check_circle</i>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <v-layout>
      <v-flex xs3 sm3 md1>
        <button class="clearButton" @click="clearFilter()">Clear</button>
      </v-flex>
      <v-flex xs9 sm9 md11>
        <button class="applyButton" @click="applyFilters">Apply</button>
      </v-flex>
    </v-layout>-->

    <div class="filter-footer-container">
      <div class="div-1">
        Results are sorted by
        <select v-model="selectedFilterSort" class="sort-select">
          <option value="ts">Upload Date</option>
          <option value="lks">Likes</option>
          <option value="km">Distance</option>
          <option value="random">Random</option>
        </select>
      </div>
      <div class="div-2"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
let vm;
import geo from "geo-hash";
import imageLinks from "../mixin/imageLinks";
export default {
  metaInfo() {
    return {
      title: "with a view"
    };
  },
  filters: {
    getName: function() {
      let str = vm.$route.query.loc;
      if (str.length > 20) {
        let s = str.substring(0, 20);
        return `${s}...`;
      } else {
        return str;
      }
    }
  },
  computed: {
    ...mapGetters(["queried_locations"])
  },
  watch: {
    selectedFilterSort: function() {
      if (this.selectedFilterSort === "km") {
        localStorage.setItem("isLocationEnabled", "Y");
        this.$store.commit("getLocationFinal");
        setTimeout(() => {
          let t1 = setInterval(() => {
            if (!this.$store.state.common.fetchLocLoader) {
              clearInterval(t1);
              if (this.$store.state.gen.finalUserLocation != "") {
                this.userGeo = geo.decode(
                  this.$store.state.gen.finalUserLocation
                );
              } else {
                this.selectedFilterSort = "ts";
              }
            }
          }, 20);
        }, 100);
      }
    }
  },
  mixins: [imageLinks],
  data() {
    return {
      selectedTagName: {
        name: "",
        type: ""
      },
      isAnyTagSelected: false,
      prevQ: {},
      filterStatus: "",
      userLoc: {},
      worldwide: false,
      selectedFilterSort: "ts",
      tags: {
        locationTag: {
          name: "Location",
          tagArr: [],
          selectedTags: []
        },
        emotionalAppeal: {
          tagLine: "Vibe of the view",
          name: "Emotional Appeal",
          tagArr: [],
          selectedTags: [],
          height: "small"
        },
        spotType: {
          tagLine: "View from",
          name: "Spot Type",
          tagArr: [],
          selectedTags: [],
          height: "big"
        },
        keywords: {
          tagLine: "View type",
          name: "Keywords",
          tagArr: [],
          selectedTags: [],
          height: "small"
        },
        viewType: {
          tagLine: "View Type",
          name: "View Type",
          tagArr: [],
          selectedTags: [],
          height: "small"
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.filterStatus === "apply") {

      this.filterStatus = "";
      let obj = {};
      if (this.tags.emotionalAppeal.selectedTags.length != 0) {
        obj.emotionalAppeal = [];
        for (let i in this.tags.emotionalAppeal.selectedTags) {
          obj.emotionalAppeal = this.tags.emotionalAppeal.selectedTags[i];
        }
      }
      if (this.tags.spotType.selectedTags.length != 0) {
        obj.st = this.tags.spotType.selectedTags[0];
      }
      if (this.tags.keywords.selectedTags.length != 0) {
        obj.keywords = this.tags.keywords.selectedTags[0];
      }
      obj.srt = this.selectedFilterSort;
      obj.srt === "km"
        ? (obj.userGeo = JSON.stringify(this.userGeo))
        : "";
      obj.loc = localStorage.getItem("filterLocation").toLowerCase() // this.worldwide? 'Elsewhere':'Berlin'
      console.log("OBJ:", obj);
      let mode = localStorage.getItem("MODE");
      this.$store.state.common.isModeSwipe =
        mode === null ? false : JSON.parse(mode);
      next({ path: to.path, query: obj });
    } else if (this.filterStatus === "clear") {
      this.filterStatus = "";
      let mode = localStorage.getItem("MODE");
      this.$store.state.common.isModeSwipe =
        mode === null ? false : JSON.parse(mode);
      next({ path: to.path, query: {} });
    } else {
      next();
    }

  },
  methods: {
    ...mapMutations(["query_location"]),
    goToRoute(selected) {
      if(localStorage.getItem("filterLocation")){
          localStorage["filterLocation"] = selected
      }
      else{
          localStorage.setItem("filterLocation",selected)
      }
      localStorage.removeItem("homePageImages");
      let obj = Object.assign({}, this.$route.query);
      obj.loc = selected;
      console.log({ obj });
      let _from = localStorage.getItem("from");
      if (_from === "Map") {
        this.$router.push({ path: `/map`, query: obj });
      } else {
        let _mode = localStorage.getItem("Mode");
        this.$store.state.common.isModeSwipe =
          _mode === null ? false : JSON.parse(_mode);
        this.$router.push({ path: `/`, query: obj });
      }
    },
    applyFilters() {
      this.filterStatus = "apply";
      setTimeout(() => {
        // console.log("***********************",localStorage.getItem("from"))
        if (localStorage.getItem("from") === "search_locations"){
          this.$router.push({ path: `/` })
        }
        else {this.$router.push({ path: `/` });}
      }, 100);
    },
    goToLocation() {
      let obj = Object.assign({}, this.$route.query);
      this.$router.push({ path: `/search_locations`, query: obj });
    },
    SelectTag(varName, tag, tagIndex) {
      this.filterStatus = "clear";
      let ele_name = document.getElementById(
        `tag-id-${varName}-${tagIndex}-name`
      );
      let ele = document.getElementById(`tag-id-${varName}-${tagIndex}`);
      if (this.tags[varName].selectedTags.includes(tag)) {
        let n = this.tags[varName].selectedTags.indexOf(tag);
        this.isAnyTagSelected = false;
        ele.style.border = "none";
        ele_name.style.height = "unset";
        ele_name.style.borderTopLeftRadius = "unset";
        ele_name.style.borderTopRightRadius = "unset";
        ele_name.style.background = `linear-gradient(to top, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0))`;
        this.tags[varName].selectedTags = "";
      } else {
        localStorage.removeItem("homePageImages");
        for (let key in this.tags) {
          this.tags[key].selectedTags = [];
        }
        ele_name.style.height = "100%";
        ele_name.style.borderTopLeftRadius = "0.5em";
        ele_name.style.borderTopRightRadius = "0.5em";
        ele_name.style.background = "rgba(0, 0, 0, 0.5)";
        // ele.style.width='100%'
        ele.style.backgroundBlendMode = `overlay`;
        ele.style.border = "1px solid #f5a623";
        this.tags[varName].selectedTags.push(tag);
        this.applyFilters();
      }
    },
    async clearFilter() {
      this.filterStatus = "clear";
      for (let i in this.tags) {
        for (let j in this.tags[i].tagArr) {
          let ele = document.getElementById(`tag-id-${i}-${j}`);
          ele.style.height = "unset";
          ele.style.width = "unset";
        }
        this.tags[i].selectedTags = [];
      }
      this.selectedFilterSort = "ts";
      this.worldwide = false;
      this.$router.replace("/filter");
    },
    async getTag(tag) {
      let vm = this;
      let tagRes = await this.$store.dispatch("getUserAllFilters", {
        tag
      });
      this.tags[tag].tagArr = tagRes;
      if (tag === "locationTag") {
        this.tags[tag].tagArr.push({
          tag: "worldwide",
          photoId: "ppufsenqmpt7pbmfzogv"
        });
      }
      if (tag === "keywords") {
        setTimeout(() => {
          this.prevQ = this.$route.query;
          console.log("this.prevQ", this.prevQ);
          let arr = Object.keys(this.prevQ);
          if (arr.includes("sortBy")) {
            this.selectedFilterSort = this.prevQ.sortBy;
          }
          function getFilterAlreadySelected(key) {
            for (let i in vm.tags[key].tagArr) {
              if (
                vm.tags[key].selectedTags.includes(vm.tags[key].tagArr[i].tag)
              ) {
                let ele_name = document.getElementById(
                  `tag-id-${key}-${i}-name`
                );
                let ele = document.getElementById(`tag-id-${key}-${i}`);
                ele_name.style.height = "100%";
                ele_name.style.borderTopLeftRadius = "0.5em";
                ele_name.style.borderTopRightRadius = "0.5em";
                ele_name.style.background = "rgba(0, 0, 0, 0.5)";
                // ele.style.width='100%'
                ele.style.backgroundBlendMode = `overlay`;
                ele.style.border = "1px solid #f5a623";
              }
            }
          }
          if (arr.includes("emotionalAppeal")) {
            this.isAnyTagSelected = true;
            vm.tags["emotionalAppeal"].selectedTags =
              vm.prevQ["emotionalAppeal"];
            this.selectedTagName.name = vm.tags["emotionalAppeal"].selectedTags;
            this.selectedTagName.type = "emotionalAppeal";

            for (let ind in this.tags["emotionalAppeal"].tagArr) {
              if (
                this.tags["emotionalAppeal"].tagArr[ind].tag ===
                this.selectedTagName.name
              )
                this.selectedTagName.index = ind;
            }
            //this.selectedTagName.index = this.tags['emotionalAppeal'].tagArr.indexOf(this.selectedTagName.name)
            getFilterAlreadySelected("emotionalAppeal");
          }
            if (arr.includes("viewType")) {
            this.isAnyTagSelected = true;
            vm.tags["viewType"].selectedTags =
              vm.prevQ["viewType"];
            this.selectedTagName.name = vm.tags["viewType"].selectedTags;
            this.selectedTagName.type = "viewType";

            for (let ind in this.tags["viewType"].tagArr) {
              if (
                this.tags["viewType"].tagArr[ind].tag ===
                this.selectedTagName.name
              )
                this.selectedTagName.index = ind;
            }
            //this.selectedTagName.index = this.tags['emotionalAppeal'].tagArr.indexOf(this.selectedTagName.name)
            getFilterAlreadySelected("viewType");
          }
          if (arr.includes("spotType")) {
            this.isAnyTagSelected = true;
            vm.tags["spotType"].selectedTags = vm.prevQ["spotType"];
            this.selectedTagName.name = vm.tags["spotType"].selectedTags;
            this.selectedTagName.type = "spotType";
            for (let ind in this.tags["spotType"].tagArr) {
              if (
                this.tags["spotType"].tagArr[ind].tag ===
                this.selectedTagName.name
              )
                this.selectedTagName.index = ind;
            }
            console.log({ r_TAGS: vm.tags["spotType"] });
            getFilterAlreadySelected("spotType");
          }
          if (arr.includes("keywords")) {
            this.isAnyTagSelected = true;
            vm.tags["keywords"].selectedTags = vm.prevQ["keywords"];
            this.selectedTagName.name = vm.tags["keywords"].selectedTags;
            this.selectedTagName.type = "keywords";

            for (let ind in this.tags["keywords"].tagArr) {
              if (
                this.tags["keywords"].tagArr[ind].tag ===
                this.selectedTagName.name
              )
                this.selectedTagName.index = ind;
            }
            //this.selectedTagName.index = this.tags['keywords'].tagArr.indexOf(this.selectedTagName.name)
            getFilterAlreadySelected("keywords");
          }
          if (arr.includes("addressIndex")) {
            this.isAnyTagSelected = true;
            console.log(" vm.prevQ.addressIndex", vm.prevQ.addressIndex);
            this.tags.locationTag.selectedTags = vm.prevQ.addressIndex;
            console.log(
              "this.tags.locationTag.selectedTags",
              this.tags.locationTag.selectedTags
            );
            setTimeout(() => {
              getFilterAlreadySelected("locationTag");
            }, 10);
          }
          if (arr.includes("loc")) {
            if (this.prevQ.loc === "Elsewhere") {
              this.worldwide = true;
              console.log("this.tags.locationTag 23", this.tags);
              this.tags.locationTag.selectedTags === undefined
                ? (this.tags.locationTag.selectedTags = [])
                : "";
              this.tags.locationTag.selectedTags.push("worldwide");
              getFilterAlreadySelected("locationTag");
              console.log("this.tags.locationTag", this.tags.locationTag);
            }
          }
        }, 400);
      }
    }
  },
  created() {
    vm = this;
    this.tags.locationTag.selectedTags = [];
    console.log("SEEEE", this.tags);
    this.getTag("locationTag");
    this.getTag("emotionalAppeal");
    this.getTag("spotType");
    this.getTag("keywords");
    if (this.$route.query.loc) {
      this.$store.state.search_loc.query_location = this.$route.query.loc;
      if(localStorage.getItem("filterLocation")){
        localStorage["filterLocation"] = this.$route.query.loc
      }else{
        localStorage.setItem("filterLocation",this.$route.query.loc)
      }
    } else {
      this.$store.state.search_loc.query_location = localStorage.getItem("filterLocation").toLowerCase();
      // if(localStorage.getItem("filterLocation")){
      //   localStorage["filterLocation"] = localStorage.getItem("filterLocation")
      // }else{
      //   localStorage.setItem("filterLocation","worldwide")
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.search-container {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding-bottom: 0.2em;

  input {
    width: 100%;
    padding-left: 1em;
    padding-right: 1.2em;
    outline: none;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    //font-family: Montserrat;
  }
}
.pointer {
  cursor: pointer;
}
.search-location-dropdown {
  background-image: url("../../static/img/keyboard_arrow_down.svg");
  background-repeat: no-repeat, repeat;
  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
  background-position: right 3px top 50%, 0 0;
  /* icon size, then gradient */
  background-size: auto, 100%, 50%;
  border-radius: 2px;
  width: 150px;
  border: none;
  font-size: 14px;
  color: white;
  select {
    outline: none !important;
  }
  option {
    font-size: 1.143em;
    color: #303030 !important;
  }
}

.sort-select {
  background: transparent url("/static/img/wav-down-arrow.svg") no-repeat;
  outline: none;
  background-position: 100% 10%;
  background-size: 2em;
  font-size: 0.909em;
  background-color: #4a4a4a;
  padding: 0.5em;
  width: 9em;
  color: #9b9b9b;
  //font-weight: 600;
}
//filter-footer-container
.filter-footer-container {
  position: relative;
  width: 100%;
  bottom: 2em;
  padding-top: 0.2em;
  //
  .div-1 {
    padding-left: 1em;
    font-size: 1em;
    top: -1em;
    right: 1em;
    color: #9b9b9b;
    background: #4a4a4a;
    position: absolute;
  }
  //
  .div-2 {
    width: 100%;
    height: 1px;
    background: black;
  }
}
.filter-container {
  position: relative;
  padding-top: 10em;
  //padding-bottom: 2em;
  background-color: #4a4a4a;
  min-height: 100vh;
  //filter-footer-container
  .filter-main-container {
    .filter-header {
      padding-right: 2.429em;
      text-align: right;
      height: 7em;
      padding-top: 1em;
    }
    position: absolute;
    width: 100%;
    top: 3em;
    margin-bottom: 2em;
    //
    .clear_icon {
      background: #4a4a4a;
      padding: 0 0.5em;
      position: absolute;
      top: -0.5em;
      color: white;
      left: 0;
    }
    //
    .t-1 {
      margin-right: 0.5em;
      font-size: 1em;
      color: #9b9b9b;
    }
    //
    .div-1 {
      padding: 0 1em;
      font-size: 1em;
      top: -1em;
      right: 1em;
      color: #9b9b9b;
      background: #4a4a4a;
      position: absolute;
    }
    //
    .div-2 {
      width: 100%;
      height: 1px;
      background: black;
    }
  }

  .scroll-contain {
    @media screen and (max-width: 375px) {
      @media screen and (max-height: 680px) {
        overflow-y: scroll;
        height: 350px;
      }
    }
  }
  //
  .filter-header-container {
    position: relative;
    margin-bottom: 2em;
    //
    .div-1 {
      padding: 0 1em;
      font-size: 1.243em;
      top: -0.65em;
      left: 1em;
      color: white;
      background: #4a4a4a;
      position: absolute;
    }
    //
    .div-2 {
      width: 100%;
      height: 1px;
      background: black;
    }
  }

  .tagline {
    font-size: 1.143em;
    color: #9b9b9b;
    margin: 1.5em 0 0.5em 0;
  }
  .tagTypes {
    display: flex;
    overflow-x: auto;
    .tag-container {
      background-position: center;
      background-size: cover;
      border-radius: 0.5em;
      margin: 0 0.5em;
      background-size: cover;
      //height: 10em;
      width: 11.429em;
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-end;
      //justify-content: space-around;
      .tagName {
        i {
          font-size: 1.2em;
        }
        border-bottom-left-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
        width: 100%;
        // background-color: red;
        text-transform: capitalize;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        background: linear-gradient(
          to top,
          rgba(0, 0, 0, 0.75),
          rgba(0, 0, 0, 0)
        );
        // border: 1.5px solid white;
        // font-size: 0.818em;
        padding: 0.5em;
        // background-color: rgba(0,0,0,0.7);
        text-align: center;
        color: white;
        font-size: 1em;
      }
    }
  }

  @mixin filterButton() {
    position: relative;
    bottom: 0;
    justify-content: center;
    display: flex;
    align-items: center;
    padding: 0;
    width: 100%;
    outline: none;
    font-size: 0.909em;
    height: 3em;
    font-weight: 600;
  }
  .clearButton {
    border: 1px solid #2c3e50;
    background-color: white;
    color: #2c3e50;
    @include filterButton;
  }
  .applyButton {
    background-color: #2c3e50;
    color: white;
    @include filterButton;
  }
}
//
.totalPhotos {
  transform: scale(1.2);
  display: flex;
  align-items: center;
  color: white;
  i {
    font-size: 1.5em;
  }
  font-size: 0.818em;
}

.selected-tag-onload {
  display: flex;
  align-items: center;
  //width: 10em;
  justify-content: flex-end;
  text-align: right;

  .name {
    display: flex;
    align-items: center;
    //width: 10em;
    justify-content: flex-end;
    padding: 0.3em 1em;
    border: 1px solid #f5a623;
    margin-bottom: 1em;
    background-color: black;

    i {
      margin-left: 0.3em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// filter.vue?2d681d59